import "../style/style.scss";

import React from "react";
import { Footer } from "src/components/Footer";
import { PageProps } from "gatsby";
import { PageContext } from "types/pageContext";
import { isPresent } from "src/utils/checks";
import DefaultNavBar from "./DefaultNavBar";
import CorporateIncentivesNavBar from "./CorporateIncentivesNavBar";
import LightNavBar from "./LightNavBar";
import DefaultOpenGraph from "components/SEO/DefaultOpenGraph";
import ErrorBoundary from "components/ErrorBoundary";
import {
  SanityClientConfigContext,
  Theme
} from "@silversea-ssc/ui-components-react";
import sanityLocation from "src/utils/sanityLocation";

const haderNavBarByType = {
  default: DefaultNavBar,
  light: LightNavBar,
  "corporate-incentives": CorporateIncentivesNavBar
};

const DefaultLayout: React.FC<PageProps<unknown, PageContext>> = ({
  pageContext,
  children
}) => {
  const language = pageContext.language;
  const alternateLinks = pageContext.alternateLinks?.filter(isPresent) || [];

  const NavBarComponent =
    haderNavBarByType[pageContext.navBarType || "default"];

  return (
    <SanityClientConfigContext.Provider value={sanityLocation}>
      <Theme>
        <ErrorBoundary>
          <DefaultOpenGraph
            language={language}
            alternateLinks={alternateLinks}
          />
        </ErrorBoundary>
        <header className="main-sticky" data-content-name="header">
          <ErrorBoundary>
            <NavBarComponent
              language={language}
              alternateLinks={alternateLinks}
            />
          </ErrorBoundary>
        </header>
        <main>{children}</main>
        <ErrorBoundary>
          <Footer language={language}></Footer>
        </ErrorBoundary>
      </Theme>
    </SanityClientConfigContext.Provider>
  );
};

export default DefaultLayout;
